import React from "react";
import GeneralStrings from "../../strings/GeneralStrings.json";
import "./ServicesPage.scss";
import { Helmet } from "react-helmet";
import GeneralConst from "../../consts/GeneralConst";
import HomepageNavbar from "../../components/HomepageNavbar/HomepageNavbar";
import Footer from "../../components/Footer/Footer";
import ServiceItem from "../../components/ServiceItem/ServiceItem";

const ServicesPage = () => {
  const SERVICES_STRINGS = GeneralStrings.SERVICES;
  const serviceItems = SERVICES_STRINGS.SERVICE_ITEMS;
  const TITLE = `${SERVICES_STRINGS.BANNER_HEADING} | ${GeneralConst.SITE_NAME}`;

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div className="services-page">
        <HomepageNavbar transparentNavbar={false} />
        <section className="page-banner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-8 col-xl-7">
                <div className="banner-heading">
                  <h1>{SERVICES_STRINGS.BANNER_HEADING}</h1>
                  <p className="banner-subheading">
                    {SERVICES_STRINGS.BANNER_SUBTEXT}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="services-content container">
          <div className="content-information-container">
            <h2 className="heading">{SERVICES_STRINGS.SERVICES}</h2>
            <h4 className="subheading">{SERVICES_STRINGS.DESCRIPTION}</h4>
          </div>
          <div className="row text-center">
            {serviceItems.map((item, i) => (
              <div className="col-md-6" key={i}>
                <ServiceItem item={item} />
              </div>
            ))}
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default ServicesPage;
